
const URL =
  process.env.NODE_ENV === 'production'
    ? 'https://api.charterscanners.ru/'
    : 'https://api.charterscanners.ru/';
export default URL;
